import { Injectable } from '@angular/core';

@Injectable()
export class CommonAlertService {
  createTypology(condition: any): Array<any> {
    const arrayAlert: any = [];
    if (condition.type === 'And') {
      condition.and.forEach((conditionInside) => {
        if (conditionInside.type === 'And') {
          conditionInside.and.forEach((ci) => {
            if (ci.type !== 'Not') {
              arrayAlert.push(ci.group);
            } else {
              arrayAlert.push(ci.not.group);
            }
          });
        } else {
          arrayAlert.push(conditionInside.group);
        }
      });
    } else if (condition.type === 'Or') {
      if (condition.or && condition.or.length >= 0) {
        condition.or.forEach((conditionInside) => {
          if (conditionInside.type === 'And') {
            conditionInside.and.forEach((ci) => {
              if (ci.type !== 'Not') {
                arrayAlert.push(ci.group);
              } else {
                arrayAlert.push(ci.not.group);
              }
            });
          } else {
            arrayAlert.push(conditionInside.group);
          }
        });
      }
    }
    return Array.from(new Set(arrayAlert)).sort();
  }

  createTypologyFirst(condition: any): Array<any> {
    const arrayAlert: any = [];
    if (condition.type === 'And') {
      condition.and.forEach((conditionInside) => {
        if (conditionInside.type === 'And') {
          conditionInside.and.forEach((ci) => {
            if (ci.type !== 'Not') {
              arrayAlert.push(ci.type);
            } else {
              arrayAlert.push(ci.not.type);
            }
          });
        } else {
          arrayAlert.push(conditionInside.type);
        }
      });
    } else if (condition.type === 'Or') {
      if (condition.or && condition.or.length >= 0) {
        condition.or.forEach((conditionInside) => {
          if (conditionInside.type === 'And') {
            conditionInside.and.forEach((ci) => {
              if (ci.type !== 'Not') {
                arrayAlert.push(ci.type);
              } else {
                arrayAlert.push(ci.not.type);
              }
            });
          } else {
            arrayAlert.push(conditionInside.type);
          }
        });
      }
    }
    const sort = Array.from(new Set(arrayAlert)).sort();
    const response = [];
    sort.forEach((elementSort) => {
      switch (elementSort) {
        case 'FieldActivityType':
          response.push('Activity');
          break;
        case 'FieldActivityDone':
          response.push('Activity');
          break;
        case 'FieldActivityTechAuthorization':
          response.push('Activity');
          break;
        case 'FieldActivityPhenologicalStage':
          response.push('Activity');
          break;
        case 'FieldActivityProductName':
          response.push('Activity');
          break;
        case 'FieldActivityProductBioUse':
          response.push('Activity');
          break;
        case 'FieldActivityProductRevoked':
          response.push('Activity');
          break;
        case 'FieldActivityAllUsers':
          response.push('Activity');
          break;
        case 'FieldActivityAnyFields':
          response.push('Activity');
          break;
        case 'MemoExpiration':
          response.push('Memo');
          break;
        case 'DeviceLongParameter':
          response.push('Device');
          break;
        case 'DeviceDoubleParameter':
          response.push('Device');
          break;
        case 'ContainerBalance':
          response.push('Container');
          break;
        case 'EquipmentInspectionDate':
          response.push('Equipment');
          break;
        case 'EquipmentTechnicalCheckDate':
          response.push('Equipment');
          break;
        case 'EquipmentTaskReceived':
          response.push('Equipment');
          break;
        case 'EquipmentGeofencingIn':
          response.push('Equipment');
          break;
        case 'EquipmentGeofencingOut':
          response.push('Equipment');
          break;
        case 'EquipmentTaskSend':
          response.push('Equipment');
          break;
        case 'LoadQuantity':
          response.push('Load');
          break;
        case 'SpaceSenseSatelliteMeanVariation':
          response.push('Satellite');
          break;
        case 'SpaceSenseSatelliteMean':
          response.push('Satellite');
          break;
        case 'IrrigationAdviceTrue':
          response.push('Irrigation');
          break;
        case 'DiseaseProtection':
          response.push('Disease');
          break;
        case 'DiseaseRisk':
          response.push('Disease');
          break;
        case 'LEVEL_OF_THE_SHEET':
          response.push('Insects');
          break;
        case 'PHEROMONE_LEVEL':
          response.push('Insects');
          break;
        case 'ALERT_THRESHOLDS':
          response.push('Insects');
          break;
        case 'DEGREE_OF_DEVELOPMENT':
          response.push('Insects');
          break;
        case 'CAPTURE':
          response.push('Insects');
          break;
      }
    });
    return Array.from(new Set(response)).sort();
  }
}
